import * as Yup from 'yup'
import {
  DeliveryInstruction,
  DELIVERY_INSTRUCTIONS,
  isCustomDeliveryInstruction,
} from '@library/api-user'

const $name = Yup.string()
  .min(3, 'Address name must be at least 3 characters')
  .max(20, 'Address name exceeds 20 characters')
  .required('Address name is required')

const $postcode = Yup.string()
  .min(3, 'Postal code must be at least three characters')
  .max(8, 'Postal code exceeds 8 characters')
  .required('Postal code is required')

const $line1 = Yup.string()
  .min(3, 'Address line must be at least 3 characters')
  .max(255, 'Address line exceeds 255 characters')
  .required('Address line is required')

const $line2 = Yup.string()
  .min(3, 'Address line must be at least 3 characters')
  .max(255, 'Address line exceeds 255 characters')

const $line3 = Yup.string()
  .min(3, 'Address line must be at least 3 characters')
  .max(255, 'Address line exceeds 255 characters')

const $town = Yup.string()
  .min(2, 'Town must be at least two characters')
  .max(255, 'Town exceeds 255 characters')
  .required('Town is required')

const $county = Yup.string()
  .min(3, 'Address line must be at least 3 characters')
  .max(255, 'Address line exceeds 255 characters')

const $deliveryInstructionsCustom = Yup.string()
  .max(32, 'Delivery instruction exceeds 32 characters')
  .optional()
  .when('deliveryInstructions', {
    is: isCustomDeliveryInstruction,
    then: (schema) => schema.required('Delivery instruction is a required field'),
  })
  .when('deliveryInstructions', {
    is: (value: DeliveryInstruction) => value === 'Neighbour',
    then: (schema) => schema.min(1, 'Delivery instruction must be at least one character'),
  })
  .when('deliveryInstructions', {
    is: (value: DeliveryInstruction) => value === 'Other',
    then: (schema) => schema.min(5, 'Delivery instruction must be at least five characters'),
  })

const $deliveryInstructions = Yup.string().oneOf(DELIVERY_INSTRUCTIONS).required()

export {
  $name,
  $postcode,
  $line1,
  $line2,
  $line3,
  $town,
  $county,
  $deliveryInstructions,
  $deliveryInstructionsCustom,
}
